import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ResponsiveHelperService } from 'src/app/services/responsive-helper.service';

@Component({
  selector: 'app-not-supported',
  templateUrl: './not-supported.component.html',
  styleUrls: ['./not-supported.component.scss']
})
export class NotSupportedComponent implements OnInit {

  constructor(
    private dialog: DynamicDialogRef,
    public responsiveHelper: ResponsiveHelperService
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.dialog.close();
  }
}
